import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComboChartAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconComboChartAxis"><Path d="M4.5 9.85938L8.06738 7.10645L8.34766 6.88965L13.2354 8.00781L20.0742 4.49023L20.7598 5.82422L13.6797 9.4668L13.4355 9.5918L13.1689 9.53125L8.7041 8.50977L4.70801 11.5938L4.5 11.7539V19.5H21.5V21H3V3H4.5V9.85938Z" fill="currentColor"/><Path d="M8.5 18H7V12H8.5V18Z" fill="currentColor"/><Path d="M13.5 18H12V13H13.5V18Z" fill="currentColor"/><Path d="M18.5 18H17V11H18.5V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconComboChartAxis;
